import i18n from "i18n/index";

const de = {
	title: "Oh! Entschuldige bitte, leider ist ein Fehler aufgetreten :-(",
	subtitle:
		"Unser Team wurde automatisch benachrichtigt und kümmert sich darum.",
	updateTitle: "Eine neue Version ist vefügbar",
	updateSubtitle: "Bitte lade die Seite, um Kultify weiter nutzen zu können",
	btnReload: "Kultify neu laden",
};

const en = {
	title: "Uh oh! We're sorry. An error just happened :-(",
	subtitle: "Our team was automatically notified and takes care of it.",
	updateTitle: "An Update is Available",
	updateSubtitle: "Please reload the page to continue with Kultify.",
	btnReload: "Reload Kultify",
};

i18n.addResourceBundle("de", "appError", de);
i18n.addResourceBundle("en", "appError", en);
